import { ReactComponent as RadioButtonActive } from "../Images/radiobutton_active.svg";
import { ReactComponent as RadioButtonDefault } from "../Images/radiobutton_default.svg";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

const RadioButton = ({
  option1,
  option2,
  option3 = null,
  optionChange,
  selectedOption,
  disabled = false,
}) => {
  const handleClick = (option) => {
    if (disabled) {
      return;
    }

    optionChange(option);
  };

  return (
    <div style={{ display: "flex", cursor: disabled ? "default" : "pointer" }}>
      <div style={{ display: "flex" }} onClick={() => handleClick(0)}>
        {selectedOption === 0 ? <RadioButtonActive /> : <RadioButtonDefault />}
        <div style={{ marginTop: "-2px", marginLeft: "7px" }}>{option1}</div>
      </div>

      <div style={{ width: "32px", height: "20px" }} />

      <div style={{ display: "flex" }} onClick={() => handleClick(1)}>
        {selectedOption === 1 ? <RadioButtonActive /> : <RadioButtonDefault />}
        <div style={{ marginTop: "-2px", marginLeft: "7px" }}>{option2}</div>
      </div>

      {option3 && (
        <div style={{ marginLeft: "32px" }}>
          <div style={{ display: "flex" }} onClick={() => handleClick(2)}>
            {selectedOption === 2 ? (
              <RadioButtonActive />
            ) : (
              <RadioButtonDefault />
            )}
            <div style={{ marginTop: "-2px", marginLeft: "7px" }}>
              {option3}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RadioButton;
